/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Universal_IdentityInputs */

const en_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universal Identity`)
};

const es_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identidad universal`)
};

const fr_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identité universelle`)
};

const de_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universelle Identität`)
};

const ja_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユニバーサルアイデンティティ`)
};

const zh_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全球通用身份`)
};

const ar_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هوية عالمية`)
};

const id_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identitas Universal`)
};

const it_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identità Universale`)
};

const ru_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Универсальная идентичность`)
};

const pt_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identidade Universal`)
};

const ko_universal_identity = /** @type {(inputs: Universal_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유니버설 아이덴티티`)
};

/**
* | output |
* | --- |
* | "Universal Identity" |
*
* @param {Universal_IdentityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const universal_identity = /** @type {((inputs?: Universal_IdentityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Universal_IdentityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_universal_identity(inputs)
	if (locale === "es") return es_universal_identity(inputs)
	if (locale === "fr") return fr_universal_identity(inputs)
	if (locale === "de") return de_universal_identity(inputs)
	if (locale === "ja") return ja_universal_identity(inputs)
	if (locale === "zh") return zh_universal_identity(inputs)
	if (locale === "ar") return ar_universal_identity(inputs)
	if (locale === "id") return id_universal_identity(inputs)
	if (locale === "it") return it_universal_identity(inputs)
	if (locale === "ru") return ru_universal_identity(inputs)
	if (locale === "pt") return pt_universal_identity(inputs)
	return ko_universal_identity(inputs)
});